$('.sitemap-section .expand-toggle').click(function(e) {
	$(this).parent()
		.find('.expandable')
		.toggleClass('expanded');

	e.preventDefault();
});